<script setup lang="ts">
import {ModelList} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import {ref} from "vue";
import type {ContactPersonFilter} from "@/types/Wiser/contactPerson.ts";
import ContactPersonFilterForm from "@/views/Wiser/ContactPersonFilterForm.vue";
const modelFilter = ref<ContactPersonFilter>({page: '1', perPage: '25'});
</script>

<template>
  <Dashboard />
  <div class="container">
    <ContactPersonFilterForm v-model="modelFilter" />
    <ModelList class="model-list model-list-contact-person" model="ContactPerson" :filter="modelFilter" />
  </div>
</template>

<style scoped></style>
